import { createStyle } from '@gluestack-style/react';

export const TabsTabIcon = createStyle({
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  mr: 12,
});
